import type { VirtualClinicAnalysisGroupByDictionary } from './dictionary';
import type {
  VirtualClinicAnalysisOperatingNumberGroupBy,
  VirtualClinicAnalysisOperatingNumberGroupByAggregation,
} from './group-by';

export const VIRTUAL_CLINIC_ANALYSIS_OPERATING_NUMBER_GROUP_BY_AGGREGATION_DEFAULT: VirtualClinicAnalysisOperatingNumberGroupByAggregation =
  {
    name: 'SUM',
  };

export const VIRTUAL_CLINIC_ANALYSIS_OPERATING_NUMBER_GROUP_BY_DEFAULT: VirtualClinicAnalysisOperatingNumberGroupBy =
  {
    fieldName: 'dismissalDateTime',
    aggregation:
      VIRTUAL_CLINIC_ANALYSIS_OPERATING_NUMBER_GROUP_BY_AGGREGATION_DEFAULT,
    parameters: [
      {
        name: 'dismissalTimeUnit',
        value: 'year',
      },
    ],
  };

export const VIRTUAL_CLINIC_ANALYSIS_OPERATING_NUMBER_GROUP_BY_DICTIONARY_DEFAULT: VirtualClinicAnalysisGroupByDictionary =
  {
    fieldNames: {
      dismissalDateTime: { de: 'Entlasszeitpunkt', en: 'Dismissal date' },
      administrativeDistrict: {
        de: 'Landkreis',
        en: 'Administrative district',
      },
    },
    aggregations: {
      SUM: { de: 'Summe', en: 'Sum' },
    },
    parameters: {
      dismissalTimeUnit: {
        de: 'Zeiteinheit',
        en: 'Time unit',
      },
    },
  };
